const colors = {
  aqua: '#00FFFF',
  beige: '#F5F1DE',
  black: '#000000',
  blue: '#0060ff',
  bronze: '#CD7F32',
  brown: '#ad825d',
  burgundy: '#8C001A',
  clear: '#F4FAFC',
  copper: '#C87533',
  cream: '#FFFFCC',
  ecru: '#C2B280',
  fuchsia: '#FF00FD',
  gold: '#D4AF37',
  green: '#00ff00',
  grey: '#d3d3d3',
  indigo: '#4b0082',
  khaki: '#f0e68c',
  lavender: '#E6E6FA',
  magenta: '#FF00FF',
  maroon: '#800000',
  metallic: '#AAA9AD',
  mustard: '#FFDB58',
  navy: '#000080',
  orange: '#FF6600',
  olive: '#808000',
  peach: '#FFDAB9',
  pink: '#ff69b4',
  purple: '#800080',
  red: '#ff0000',
  'rose gold': '#DDB68B',
  rust: '#B7410E',
  silver: '#cccccc',
  tan: '#D2B48C',
  teal: '#008080',
  violet: '#EE82EE',
  white: '#f3f3f3',
  wine: '#361B24',
  yellow: '#ffff00',
  nud: '#f8c890',
  nude: '#F8C890'
};

module.exports = function hexCode(name) {
  return colors[name];
};
